/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 11:25:49
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-14 11:31:18
 * @name: 工单管理-售后列表
 * @Description: 工单管理-售后列表
 * @FilePath: \preSaleNafterSaleInside\project\src\Validator\issue\getList.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'type',
    description: '类型 all所有(默认) check审批 todo待处理 ensure待确认 fail失败 finish已处理',
    required: true,
    required_message: '类型为必传项',
    match: (e) => {
      if(!['all','check','todo','ensure','fail','finish'].includes(e)) {
        return 'type须为all、check、todo、ensure、fail或finish';
      } else {
        return '';
      }      
    }
  },
  {
    key: 'piano_no',
    description: '琴号',
    required: false,
    match: (e) => {
      return '';   
    }
  },
  {
    key: 'issue_name',
    description: '问题类型',
    required: false,
    match: (e) => {
      return '';   
    }
  },
  {
    key: 'musical',
    description: '乐器类别',
    required: false,
    match: (e) => {
      return '';   
    }
  },
  {
    key: 'start_time',
    description: '最早时间',
    required: false,
    match: (e) => {
      return '';   
    }
  },
  {
    key: 'end_time',
    description: '最晚时间',
    required: false,
    match: (e) => {
      return '';   
    }
  },
]